// NPM Imports
import React from "react";
import PropTypes from "prop-types";

// CSS imports
import style from "./revvNumberInput.module.scss";

// Components Imports
import Input from "../Input";

// Declarations
export const MAX_LIMIT = 1000000000000000000000;
export const INTEGER_REGEX = /^[0-9\b]+$/;
export const FLOAT_REGEX = /^([0-9]\d*)(\.[0-9]*?)?$/;

export default function NumberInput(props) {
  const {
    className,
    currencySymbol,
    isFloat,
    limitTo,
    onChange,
    type,
    value: inputValue,
    ...otherProps
  } = props;

  const CHARACTER_LIMIT = type === "percentage" ? 100 : limitTo || MAX_LIMIT;

  function _isFloat(num) {
    return num === "" || FLOAT_REGEX.test(num);
  }

  const _isNumber = value => {
    if (type === "percentage" || isFloat) {
      return _isFloat(value);
    }
    return value === "" || INTEGER_REGEX.test(value);
  };

  function _onValueChange(event) {
    const { value } = event.target;
    let newValue = 0;
    if (_isNumber(value)) {
      // Handle Floating point inside input type
      if (type === "percentage" || isFloat) {
        if (value === "") {
          newValue = "";
        } else if (value.indexOf(".") > 0 && _isFloat(value)) {
          newValue = value;
        } else {
          newValue = Number(value);
        }
      }
      // If the type is Integer
      else {
        newValue = value === "" ? "" : Number(value);
      }
      if (newValue <= CHARACTER_LIMIT) {
        props.onChange(newValue);
      }
    }
  }

  // * IF TYPE IS PASSED AS CURRENCY
  if (type === "currency") {
    return (
      <div className={`${style.currencyContainer} ${className}`}>
        <span className={style.currencyIcon}>{currencySymbol}</span>
        <Input
          data-test="numberinput"
          onChange={_onValueChange}
          value={inputValue}
          {...otherProps}
        />
      </div>
    );
  }

  // * IF TYPE IS PASSED AS PERCENTAGE
  if (type === "percentage") {
    return (
      <div className={`${style.percentContainer} ${className}`}>
        <Input
          data-test="numberinput"
          onBlur={props.onBlur}
          onChange={_onValueChange}
          value={inputValue}
          {...otherProps}
        />
        <span className={style.percentageIcon}>%</span>
      </div>
    );
  }

  // * IF NO TYPE IS PASSED
  return (
    <Input
      data-test="numberinput"
      value={inputValue}
      onChange={_onValueChange}
      className={`${className}`}
      {...otherProps}
    />
  );
}

NumberInput.defaultProps = {
  className: "",
  currencySymbol: "$",
  isFloat: false,
  limitTo: null,
  onBlur: () => {},
  type: "",
  value: "",
};

NumberInput.propTypes = {
  className: PropTypes.string,
  currencySymbol: PropTypes.string,
  isFloat: PropTypes.bool,
  limitTo: PropTypes.number,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
